import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dattoRmm = defineConnector({
  identifier: "dattoRmm",
  name: "Datto RMM",
  tagLine: "Remote monitoring and management",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://[^/]*-api\\.centrastage\\.net/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your Datto RMM instance details",
      items: [
        {
          kind: "markdown",
          content: "Enter the details for your Datto RMM instance.",
        },
        {
          kind: "input",
          label: "Platform",
          placeholder: "merlot",
          required: true,
          target: { kind: "configuration", field: "platform" },
          helperText:
            "The Datto RMM platform (region) for your account (e.g. https://merlot-api.centrastage.net)",
        },
      ],
    },
    {
      title: "Create a Datto RMM app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Datto RMM API docs](https://rmm.datto.com/help/en/Content/4WEBPORTAL/Integrations/APIv2.htm) and register an API application in Datto RMM. Copy the client ID and client secret, and note the Datto platform value for your tenant.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/dattoRmm/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Datto RMM account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Datto RMM account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: (configuration) =>
      `https://${configuration.platform}-api.centrastage.net/auth/oauth/authorize`,
    tokenEndpoint: (configuration) =>
      `https://${configuration.platform}-api.centrastage.net/auth/oauth/token`,
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://${configuration.platform}-api.centrastage.net/api/`,
  },
  publicEnvVars: ({ platform }) => ({
    DATTO_RMM_PLATFORM: platform || "",
  }),
});
